/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_AnalyzingInputs */

const en_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fr_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const es_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const it_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const nl_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const pl_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fi_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const da_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const sv_story_bank_analyzing = /** @type {(inputs: Story_Bank_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Story_Bank_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_analyzing = /** @type {((inputs?: Story_Bank_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_analyzing(inputs)
	if (locale === "fr") return fr_story_bank_analyzing(inputs)
	if (locale === "es") return es_story_bank_analyzing(inputs)
	if (locale === "it") return it_story_bank_analyzing(inputs)
	if (locale === "nl") return nl_story_bank_analyzing(inputs)
	if (locale === "pl") return pl_story_bank_analyzing(inputs)
	if (locale === "fi") return fi_story_bank_analyzing(inputs)
	if (locale === "da") return da_story_bank_analyzing(inputs)
	if (locale === "sv") return sv_story_bank_analyzing(inputs)
	return en_story_bank_analyzing(inputs)
});